import 'bootstrap';
import { Modal, Tooltip } from 'bootstrap';

import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';

import index from './index';
import './components/Helpers';
import './components/Naja';

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Autoplay = Autoplay;
window.Pagination = Pagination;

// Webpack HMR
if (module.hot) {
	module.hot.accept();
}
